import React, {useEffect} from 'react';

import CSSModules from 'react-css-modules';

import Heading from '../../../TextComponents/Heading';
import type {TextColours} from '../../../TextComponents/textUtils';
import {createMarkup} from '../../../utils/markdownUtils';
import PreviewNavButton from '../PreviewNavButton';

import styles from './styles.module.scss';

type LearningOutcomesSlideProps = {
  title?: string;
  outcomes?: string[];
  cheer?: string;
  background: string;
  editMode?: boolean;
  reskinClassName?: string;
  textColor?: TextColours;
  button: {
    text: string;
  };
  isPreviewMode?: boolean;
  isButtonLightTheme?: boolean;
};

// eslint-disable-next-line complexity
const LearningOutcomesSlide = ({
  title,
  outcomes,
  cheer,
  background,
  editMode = false,
  reskinClassName = '',
  textColor,
  button,
  isPreviewMode = false,
  isButtonLightTheme = false,
}: LearningOutcomesSlideProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div
        styleName={`container${editMode ? ' editing' : ''} ${reskinClassName} ${
          isPreviewMode ? ' preview-mode' : ''
        }`}
        style={{
          backgroundColor: background,
          color: textColor !== 'white' ? '#1E1E34' : 'white',
        }}
        data-automation={`slide${editMode ? '-preview' : ''}${
          isPreviewMode ? '-thumbnail' : ''
        }`}
      >
        <div styleName='content'>
          <div style={{margin: 'auto'}}>
            <Heading
              as='h1'
              size='leopard'
              weight='medium'
              colour={textColor}
              dataAutomation={`title-text${editMode ? '-preview' : ''}${
                isPreviewMode ? '-thumbnail' : ''
              }`}
            >
              {title || ''}
            </Heading>
            <ul styleName='learning-outcomes'>
              {outcomes &&
                outcomes.map((outcome, idx) => (
                  <li
                    dangerouslySetInnerHTML={createMarkup(outcome)}
                    key={idx}
                    data-automation={`learning-outcome-text${
                      editMode ? '-preview' : ''
                    }${isPreviewMode ? '-thumbnail' : ''}`}
                  />
                ))}
            </ul>
            <div styleName='outro'>
              <Heading
                as='h2'
                size='sheep'
                colour={textColor}
                dataAutomation={`extra-text${editMode ? '-preview' : ''}${
                  isPreviewMode ? '-thumbnail' : ''
                }`}
              >
                <div dangerouslySetInnerHTML={createMarkup(cheer || '')} />
              </Heading>
            </div>
          </div>
        </div>
      </div>
      {button && !isPreviewMode && (
        <PreviewNavButton
          button={button}
          background={background}
          isLightTheme={isButtonLightTheme}
        />
      )}
    </>
  );
};

export default CSSModules(LearningOutcomesSlide, styles, {allowMultiple: true});
